import { createPortal } from "react-dom";

import Warning from "../Warning/Warning";

import "./styles.scss";

/**
 * Asks the user to confirm an action before it runs, using the app's standard
 * warning dialog.
 *
 * It is rendered into the portal root because the buttons that open it often
 * sit inside table cells, where a fixed dialog can be trapped by the table's
 * stacking context or overflow. React still bubbles events through a portal
 * to the component tree it came from, so clicks are stopped here; otherwise a
 * click on the dialog would also reach the cell and expand or collapse its row.
 */
const ConfirmDialog = ({
  show,
  setShow,
  onConfirm,
  article = "Are you sure?",
  children,
  textOK = "Yes",
  textCancel = "Cancel",
}) => {
  if (!show) return null;

  const confirmHandler = () => {
    setShow(false);
    onConfirm();
  };

  return createPortal(
    <div onClick={(e) => e.stopPropagation()}>
      <Warning
        show={show}
        setShow={setShow}
        onClickOk={confirmHandler}
        article={article}
        text={children}
        textOK={textOK}
        textCancel={textCancel}
      />
    </div>,
    document.getElementById("portal") || document.body,
  );
};

export default ConfirmDialog;
